import { Plugin } from '@ckeditor/ckeditor5-core';
import { WidgetToolbarRepository } from '@ckeditor/ckeditor5-widget';
import VideoUtils from './videoutils';
import { isObject } from 'lodash-es';
export default class VideoToolbar extends Plugin {
    /**
     * @inheritDoc
     */
    static get requires() {
        return [WidgetToolbarRepository, VideoUtils];
    }
    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'VideoToolbar';
    }
    /**
     * @inheritDoc
     */
    afterInit() {
        const editor = this.editor;
        const t = editor.t;
        const widgetToolbarRepository = editor.plugins.get(WidgetToolbarRepository);
        const videoUtils = editor.plugins.get('VideoUtils');
        widgetToolbarRepository.register('video', {
            ariaLabel: t('Video toolbar'),
            items: normalizeDeclarativeConfig(editor.config.get('video.toolbar') || []),
            getRelatedElement: selection => videoUtils.getClosestSelectedVideoWidget(selection)
        });
    }
}
function normalizeDeclarativeConfig(config) {
    return config.map(item => isObject(item) ? item['name'] : item);
}
//# sourceMappingURL=videotoolbar.js.map